


































































































































































































import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import CampoDeItemDeVenda from '@/components/venda/CampoDeItemDeVenda.vue'
import {
	FormProdutoBaseSimples,
	ItemDaVenda,
	Loja,
	PontoDeVenda,
	ProdutoProjection,
} from '@/models'
import {
	ItemDeRomaneio,
	ItemDeRomaneioForm,
	RomaneioForm,
} from '@/models/Romaneio'
import { converterProdutoParaProdutoSimples, displayNomeCompletoDoProduto, obterQuantidadePesadaNaBalanca } from '@/shareds/produto-shareds'
import { obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { FindConfiguracaoDaContaUseCase, FindLojaUseCase, FindProdutoUseCase } from '@/usecases'
import { RomaneioEstoqueUseCase } from '@/usecases/loja/RomaneioEstoqueUseCase'
import { CancelTokenSource } from 'axios'
import { Component, Ref, Vue } from 'vue-property-decorator'
import VueQuagga from "vue-quaggajs"

Vue.use(VueQuagga);

@Component({
	components: {
		CampoDeItemDeVenda,
		SeletorDeLojas,
		Confirmacao,
	},
})
export default class DialogoDeRomaneioDeEstoque extends Vue {
	@Ref() readonly campoDeBusca!: CampoDeItemDeVenda
	@Ref() confirmar!: Confirmacao 

	obrigatorio = obrigatorio

	mostra = false
	loading = false
	tipoMovimentacao: string | null = null
	itens: ProdutoProjection | null = null
	produto: FormProdutoBaseSimples[] = []
	itemDeRomaneio: ItemDeRomaneio[] = []
	itemDeRomaneioForm: ItemDeRomaneioForm[] = []
	romaneio: RomaneioForm | null = null
	depositoId: string | null = null
	romaneioEstoqueUseCase = new RomaneioEstoqueUseCase()
	findProdutoUseCase = new FindProdutoUseCase()
	findConfiguracaoDaContaUseCase = new FindConfiguracaoDaContaUseCase()
	busca: string | null = null
	loja: Loja | null = null
	lojaSelecionada: string | null = null
	pontosDeVenda: PontoDeVenda[] = []
	cancelTokenDeposito: CancelTokenSource | null = null
	observacao: string | null = null
	depositoDestino: string | null = null
	findLojaUseCase = new FindLojaUseCase()
	buscaPorRomaneio = true
	zerarTodoEstoque = false
	showCamera = false
	mostrarDialogoLeituraDeCodigoBarras = false
	buscandoProduto = false
	valorLido: string | null = null

	readerSize = {
		width: 860,
		height: 480,
	}

	headers = [
		{ text: 'Entrada', value: 'Entrada' },
		{ text: 'Saída', value: 'Saida' },
		{ text: 'Transferência', value: 'Transferencia' },
		{ text: 'Balanço', value: 'Balanco' },
	]

	get idUsuarioLogado(): string | undefined {
		return UserLoginStore.usuario?.id || undefined
	}

	get tipoTranferencia() {
		if (this.tipoMovimentacao == 'Transferencia') return true
		return false
	}

	async mostrar(idDeposito?: string, loja?: Loja) {
		this.depositoId = idDeposito || null
		this.loja = loja || null
		this.mostra = true
	}

	cancelar() {
		this.mostra = false
		this.itemDeRomaneio = []
		this.itemDeRomaneioForm = []
		this.tipoMovimentacao = ''
		this.lojaSelecionada = null
		this.observacao = ''
	}

	beep() {
		const audio = document.querySelector('audio')
		if(!audio) return 
		audio.play()
	}

	
	async logIt(data: any) {
		this.showCamera = false
		this.buscandoProduto = true
		this.beep()
		this.valorLido = data.codeResult.code

		if (this.valorLido && this.loja) {
			try {
				const produto = await this.findProdutoUseCase.findProdutoComEstoque(
					this.valorLido,
					this.loja.id,
				)

				const configuracaoDeConta = await this.findConfiguracaoDaContaUseCase.find()

				const quantidadeDeItens =
					produto.unidadeDeMedida !== 'KG' && produto.unidadeDeMedida != 'MT'
						? 1
						: obterQuantidadePesadaNaBalanca(
							'',
							configuracaoDeConta?.medida || 6,
							configuracaoDeConta?.eans || 7,
							configuracaoDeConta?.casasNumericas || 4,
						)
				const item: ItemDaVenda = {
					id: '',
					produto: converterProdutoParaProdutoSimples(produto),
					quantidade: quantidadeDeItens,
					desconto: { isPercentual: true, valor: 0.0 },
					preco: produto.preco || 0,
					precoDeCusto: 0,
					idConjunto: null,
					descontoVarejo: 0,
					percentualCashback: 0,
					diasParaEfetivarCashback: 0,
					valorDescontoRateadoDoItem: 0,
					idItemOrigem: '',
				}

				this.incluirItens(item)
			} catch (error) {
				AlertModule.setError(error)
			} finally {
				this.buscandoProduto = false
				this.showCamera = true
			}
		}
	}

	async zerarEstoque() {
		if(this.zerarTodoEstoque) 
			return await this.confirmar.mostrar()

		this.concluirRomaneio()	
	}

	async concluirRomaneio() {
		this.loading = true
		this.itemDeRomaneio.forEach(item => {
			this.itemDeRomaneioForm.push({
				id: '',
				produto: item.produto.id || '',
				quantidade: item.quantidade,
			})
		})

		try {
			await this.buacarlojaSelecionada()
			await this.romaneioEstoqueUseCase.salvarRomaneio({
				id: '',
				sequenciaNumerica: 0,
				tipoMovimentacaoRomaneio: this.tipoMovimentacao || '',
				usuarioCrio: this.idUsuarioLogado || '',
				usuarioConfirmou: '',
				statusRomaneio: 'Pendente',
				deposito: this.depositoId || '',
				dataHoraCriacao: new Date(),
				itens: this.itemDeRomaneioForm,
				depositoDestino: this.depositoDestino 
					? this.depositoDestino 
					: this.depositoId || '',
				observacaoRomaneio: this.observacao || '',
				zerarTodoEstoque: this.zerarTodoEstoque,
			})
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.itemDeRomaneio = []
			this.itemDeRomaneioForm = []
			this.tipoMovimentacao = ''
			this.itemDeRomaneioForm = []
			this.tipoMovimentacao = ''
			this.lojaSelecionada = null
			this.observacao = ''
			this.loading = false
			this.mostra = false
			this.zerarTodoEstoque = false
			AlertModule.setSuccess('Romaneio criado com sucesso')
		}
	}

	async buacarlojaSelecionada() {
		if (!this.lojaSelecionada) return
		try {
			const axiosConfig = {
				cancelToken: this.cancelTokenDeposito?.token,
			}

			const depositoPage = await this.findLojaUseCase.findDepositoDaLojaById(
				this.lojaSelecionada,
				axiosConfig,
			)

			if (!depositoPage.content[0])
				throw new Error('Deposito da loja não encontrado')
			this.depositoDestino = depositoPage.content[0].id || ''
		} catch (error) {
			AlertModule.setError(error)
		}
	}

	async incluirItens(item: ItemDaVenda) {
		this.loading = true
		if (!item.produto.eans[0]) return
		if (!this.loja) {
			AlertModule.setError('Selecione uma loja!')
			return
		}
		try {
			const itemDeRomaneioNovo: ItemDeRomaneio = {
				id: '',
				produto: {
					id: item.produto.id,
					nome: displayNomeCompletoDoProduto(item.produto),
					tipo: item.produto.tipo,
					preco: item.produto.preco,
					pesoLiquido: item.produto.pesoLiquido,
					pesoBruto: item.produto.pesoBruto,
					eans: item.produto.eans,
					sku: item.produto.sku || '',
					identificadores: item.produto.identificadores,
					nomeCompleto: item.produto.nomeCompleto,
					produtoDesativado: item.produto.produtoDesativado,
					descontoVarejo: item.produto.descontoVarejo,
				},
				quantidade: 1,
			}

			const indiceDoItemBipado = this.itemDeRomaneio.findIndex(
				item => item.produto.sku === itemDeRomaneioNovo.produto.sku,
			)
			const itemAnterior = this.itemDeRomaneio[indiceDoItemBipado]
			const quantidade =
				indiceDoItemBipado === -1
					? item.quantidade
					: itemAnterior.quantidade + item.quantidade

			if(this.tipoMovimentacao !== 'Balanco' && this.tipoMovimentacao !== 'Entrada') {
				await this.findProdutoUseCase.findProdutoComEstoqueRomaneio(
					item.produto.eans[0],
					this.loja.id,
					quantidade,
					this.tipoMovimentacao || "",
				)
			}

			if (indiceDoItemBipado === -1) {
				this.itemDeRomaneio.unshift(itemDeRomaneioNovo)
				return
			}

			this.itemDeRomaneio.splice(indiceDoItemBipado, 1)

			this.itemDeRomaneio.unshift({
				...itemAnterior,
				quantidade: itemAnterior.quantidade + item.quantidade,
			})
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.loading = false
		}
	}

	deleteItem(item: any) {
		const idx = this.itemDeRomaneio.indexOf(item)
		if (idx !== -1) {
			this.itemDeRomaneio.splice(idx, 1)
		}
	}
}
